import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const attachAuthToken = (auth) => {
  apiClient.interceptors.request.use(
    (config) => {
      const token = auth?.user?.id_token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        delete config.headers.Authorization;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

export default apiClient;
